<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Customers from '@/services/Customers';
    import modalAddCompany from '@/components/modals/customers/modalAddCompany';
    import modalEditCompany from '@/components/modals/customers/modalEditCompany';
    import _ from 'underscore';
    import modalAttachExternalCompany from "@/components/modals/business/modalAttachExternalCompany";
    import Swal from "sweetalert2";

    export default {
        components: {
          Layout,
          PageHeader,
          modalAddCompany,
          modalAttachExternalCompany,
          modalEditCompany,
        },
        page: {
            title: "Business Companies",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
         data() {
            return {
                selectedCompanyData:null,
                isAuthorized: false,
                error: null,
                filterData: false,
                showMapData: false,
                showMap: false,
                tableData: [],
                title: "Business Companies",
                items: [
                    {
                        text: "CRM",
                        href: "/customers/companies",
                    },
                    {
                        text: "Companies",
                        active: true,
                    },
                ],
                ticketing_client_types:[],
                userStatuses: [],
                filterInput: {
                    name: '',
                    gender: [],
                    company_id: '',
                    userStatus: [],
                },
                modalData: {},
                companyData: [],
                countries: [],
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "created_on",
                sortDesc: true,
                fields: [

                    {
                        key: "name",
                        label: "Company Name",
                        sortable: true,
                    },
                    {
                      key: "description",
                      label: "Description",
                      sortable: true,
                    },
                    {
                        key: "website",
                        label: "Website",
                        sortable: true,
                    },
                    {
                      key: "email",
                      label: "Email",
                      sortable: true,
                    },
                    {
                        key: "background_color",
                        label: "Background Color",
                        sortable: true,
                    },
                    // {
                    //   key: "company_image",
                    //   label: "Company Image",
                    //   sortable: true,
                    // },
                    {
                        key: "logo_url",
                        label: "Logo Image",
                        sortable: true,
                    },
                    {
                        key: "labels",
                        label: "Labels",
                        sortable: false,
                    },
                    "action"
                ],
            };
        },

        methods: {

            openAttachExternalCompanyModal(data){
              this.selectedCompanyData = data;
              this.$bvModal.show('attach_external_company_modal')
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            modalAddCompany(){
                this.$bvModal.show("add_new_company");
            },

            async getCompanies(){
                try {
                    this.toggleBusy();
                    var filters = this.getFilters()
                    // prevent heavy /business/companies response (members/assets) from timing out
                    filters += filters.includes('club_members=') ? '' : '&club_members=no';
                    const response = await Customers.getCompanies(filters)
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                    this.currentPage = 1
                    this.filterData = true
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                    this.currentPage = 1
                    this.filterData = true
                } finally {
                    this.toggleBusy();
                }
            },

            getFilters(){
                var filter_string = '?limit=1000';
                filter_string += (this.filterInput.name) ? '&name='+this.filterInput.name : "";
                filter_string += (this.filterInput.company_id) ? '&company_id='+this.filterInput.company_id : "";
                return filter_string = filter_string.substring(1);
            },

            callModalCompanyEdit(data) {
                this.modalData = data;
                this.$nextTick(() => {
                    this.$bvModal.show("company_edit");
                });
            },
       
            labelBadgeStyle(label) {
                const bg = label.color || "#6c757d";
                return {
                    backgroundColor: bg,
                    color: this.labelTextColor(bg),
                };
            },
            labelTextColor(hex) {
                if (!hex) {
                    return "#fff";
                }
                const color = hex.replace("#", "");
                if (color.length !== 6) {
                    return "#fff";
                }
                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                return luminance > 0.6 ? "#212529" : "#fff";
            },

            async detachFromExternalCompany(company_id, external_company_id) {
            Swal.fire({
              title: "Detach External Company?",
              text: "This Company will be detached from External Provider!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Detach!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const payload = {
                          company_id:company_id,
                          external_company_id: external_company_id,
                        };
                        const response = await Customers.detachFromExternalCompany(payload);
                        console.log(response);
                        if (response.data.data == 'success') {
                            this.getCompanies();
                            Swal.fire("Success!", "External Company is successfully detached !", "success");
                        } else {
                            let errorMessage = response.error ? response.error : 'Failed';
                            if (typeof errorMessage === 'object') {
                                errorMessage = errorMessage[0];
                            }
                            Swal.fire("Fail!", errorMessage, "warning");
                        }
                    } catch (error) {
                        let errorMessage = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : "An error occurred while detach external company!";
                        if (typeof errorMessage === 'object') {
                          errorMessage = errorMessage[0];
                        }
                        Swal.fire("Error", errorMessage, "error");
                    }
                }
            });
          },

        },
        mounted() {
            this.getCompanies();
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">

                <div class="card" v-show="filterData">
                    <div class="card-body">
                            <div>
                                <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                                   @click="modalAddCompany">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Create New
                                </a>
                            </div>
                        <div class="row mt-2">
                            <div class="col d-inline-flex align-items-center" >
                                <h4 class="card-title m-0">Total Companies: {{totalRows}}</h4>
                            </div>
                        </div>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0" v-show="filterData">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                @filtered="onFiltered"
                                show-empty
                                empty-text="No Data Found"
                            >
                               
                                <template v-slot:cell(company_id)="data">
                                    {{ data.item.company_id }}
                                </template>

                                <template v-slot:cell(website)="data">
                                    <a :href="data.item.website" >
                                        <span>{{data.item.website}}</span>
                                    </a>
                                </template>
<!--                                <template v-slot:cell(company_image)="data">-->
<!--                                  <img :src="data.item.company_image" style="width: 80px;" />-->
<!--                                </template>-->
                                <template v-slot:cell(logo_url)="data">
                                    <div
                                        class="company-table-logo"
                                        :style="{ backgroundColor: data.item.background_color || '#e8edf2' }"
                                    >
                                        <img
                                            v-if="data.item.logo_url"
                                            :src="`${data.item.logo_url}?ts=${Date.now()}`"
                                            :alt="data.item.name"
                                            class="company-table-logo__img"
                                        />
                                    </div>
                                </template>
                                <template v-slot:cell(labels)="data">
                                    <span
                                        v-if="!data.item.labels || !data.item.labels.length"
                                        class="text-muted"
                                    >—</span>
                                    <span
                                        v-else
                                        v-for="label in data.item.labels"
                                        :key="label.id"
                                        class="badge me-1 mb-1 label-badge"
                                        :style="labelBadgeStyle(label)"
                                        v-b-tooltip.hover
                                        :title="label.description || label.name"
                                    >
                                        {{ label.name }}
                                    </span>
                                </template>
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template  v-slot:cell(background_color)="data">
                                    <ul class="list-inline mb-0 d-flex" style="gap: 10px;">
                                        <span :style="{ display:'block', width:'20px', height:'20px', background: data.item.background_color,  padding:'5px', border:'1px solid black' }"></span>
                                        <span >{{data.item.background_color}}</span>
                                    </ul>

                                </template>
                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 d-flex">
                                        <li class="list-inline-item">
                                            <router-link title="View Company" :to="{ path: `/customers/companies/${data.item.company_id}`}">
                                                <i class="uil uil-eye font-size-18"></i>
                                            </router-link>
                                        </li>
                                        <li class="list-inline-item" v-if="data.item.external_provider !== 'tymes4'">
                                          <a v-if="!data.item.external_company_id" href="javascript:void(0);" class="px-2 text-black" title="Attach External Company" @click="openAttachExternalCompanyModal(data.item)">
                                            <i class="uil uil-paperclip font-size-18" style="color: #5b73e8"></i>
                                          </a>
                                          <a v-else href="javascript:void(0);" class="px-2 text-black" title="Detach External Company" @click="detachFromExternalCompany(data.item.company_id,data.item.external_company_id)">
                                            <i class="uil uil-link-broken font-size-18" style="color: red"></i>
                                          </a>
                                      </li>
                                      <li class="list-inline-item">
                                            <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Company" @click="callModalCompanyEdit(data.item)">
                                                <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                        </li>

                                    </ul>
                                </template>
                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalAddCompany @onRefresh="getCompanies()"></modalAddCompany>
        <modalAttachExternalCompany
            @onRefresh="getCompanies()"
            :selectedCompanyData="selectedCompanyData"
        ></modalAttachExternalCompany>
        <modalEditCompany
                    :modalData="modalData"
                    @onRefresh="getCompanies()"
         ></modalEditCompany>

    </Layout>
</template>

<style scoped>
.label-badge {
    font-weight: 500;
    font-size: 12px;
}

.company-table-logo {
    width: 80px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    box-sizing: border-box;
}

.company-table-logo__img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
</style>
